"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuyBox = exports.DigitalBuyButton = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = require("styled-components");
const monera_app_core_1 = require("@amzn/monera-app-core");
const monera_app_core_2 = require("@amzn/monera-app-core");
const canvas_box_1 = require("../canvas-box");
const divider_1 = require("../divider");
const hoc_1 = require("../hoc");
const product_price_1 = require("../product-price");
const retail_buy_button_1 = require("../retail-buy-button");
const themed_text_1 = require("../themed-text");
const styles_1 = require("./styles");
const BuyBoxComponent = (_a) => {
    var { width = '250px', padding = '14px 18px', justify = 'center', direction = 'column', minWidth = '250px', hideBorders = false } = _a, props = __rest(_a, ["width", "padding", "justify", "direction", "minWidth", "hideBorders"]);
    const renderCanvasItems = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(canvas_box_1.CanvasItem, null,
            react_1.default.createElement(product_price_1.ProductPrice, { priceToPayDisplayString: props.priceToPayDisplayString })),
        props.priceFooterCopy && (react_1.default.createElement(canvas_box_1.CanvasItem, null,
            react_1.default.createElement(themed_text_1.ThemedSpan, { font: "base" }, props.priceFooterCopy))),
        props.callToAction ? react_1.default.createElement(retail_buy_button_1.RetailBuyButton, Object.assign({}, props)) : react_1.default.createElement(exports.DigitalBuyButton, Object.assign({}, props))));
    return (react_1.default.createElement(styles_1.BorderBuyBoxContainer, Object.assign({ width: width, minWidth: minWidth, padding: padding, justify: justify, direction: direction, hideBorders: hideBorders }, props), renderCanvasItems));
};
const DigitalBuyButton = (props) => {
    const [configStoreState] = (0, monera_app_core_1.useConfigStore)();
    const theme = (0, styled_components_1.useTheme)();
    const spacings = theme.spacings;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(divider_1.Divider, { margin: `${spacings.small} 0` }),
        !props.isAuthenticatedUser && (react_1.default.createElement(canvas_box_1.CanvasItem, { margin: `0px 0px ${spacings.base}`, textAlign: "center" },
            react_1.default.createElement(themed_text_1.ThemedSpan, { font: "base" }, props.signInMessageCopy))),
        react_1.default.createElement(canvas_box_1.CanvasItem, { width: "100%" },
            react_1.default.createElement(styles_1.FullWidthButton, { "aria-label": props.isAuthenticatedUser ? props.buyNowAriaLabelCopy : props.signInAriaLabelCopy, "data-cy": 'buy-now', buttonType: 'buyNow', onClick: () => {
                    props.isAuthenticatedUser
                        ? (window.location.href = props.buyUrl)
                        : (0, monera_app_core_2.redirectToAuthPortalV2)(configStoreState.countryCode);
                } }, props.isAuthenticatedUser ? props.buyNowCopy : props.signInCopy))));
};
exports.DigitalBuyButton = DigitalBuyButton;
exports.BuyBox = (0, hoc_1.withCriticalFeature)(BuyBoxComponent);
__exportStar(require("./types"), exports);
